import tagsMutations from "./mutations.js";
import tagsActions from "./actions.js";
import tagsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      tags : {}
    };
  },
  mutations: tagsMutations,
  actions: tagsActions,
  getters: tagsGetters,
};
